import { TSubscriptionPlanType } from '@/helpers/subscription';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ name: 'checkout', namespaced: true })
export default class CheckoutModule extends VuexModule {
  selectedPlan: TSubscriptionPlanType = null;
  paymentProcessing: boolean = false;
  plans: any = null;
  hasAgreedToTerms: boolean = false;
  displayAgreeToTermsError: boolean = false;

  @Action
  setSelectedPlan(plan: TSubscriptionPlanType) {
    this.context.commit('SET_SELECTED_PLAN', plan);
  }

  @Mutation
  SET_SELECTED_PLAN(plan: TSubscriptionPlanType) {
    this.selectedPlan = plan;
  }

  @Action
  setPaymentProcessing(paymentProcessing: boolean) {
    this.context.commit('SET_PAYMENT_PROCESSING', paymentProcessing);
  }

  @Mutation
  SET_PAYMENT_PROCESSING(paymentProcessing: boolean) {
    this.paymentProcessing = paymentProcessing;
  }

  @Action
  setPlans(plans) {
    this.context.commit('SET_PLANS', plans);
  }

  @Mutation
  SET_PLANS(plans) {
    this.plans = plans;
  }

  @Action
  setHasAgreedToTerms(hasAgreedToTerms: boolean) {
    this.context.commit('SET_HAS_AGREED_TO_TERMS', hasAgreedToTerms);
  }

  @Mutation
  SET_HAS_AGREED_TO_TERMS(hasAgreedToTerms: boolean) {
    this.hasAgreedToTerms = hasAgreedToTerms;
  }

  @Action
  setDisplayAgreeToTermsError(displayAgreeToTermsError: boolean) {
    this.context.commit('SET_DISPLAY_AGREE_TO_TERMS_ERROR', displayAgreeToTermsError);
  }

  @Mutation
  SET_DISPLAY_AGREE_TO_TERMS_ERROR(displayAgreeToTermsError: boolean) {
    this.displayAgreeToTermsError = displayAgreeToTermsError;
  }
}
